import { LightAlert } from 'components/shared/LightAlert';
import type { IntlKey } from 'locales';
import { FC, ReactNode, useMemo } from 'react';
import { useIntl } from 'react-intl';
import type { AlertSeverity } from 'state/notifications/notification.model';

type ErrorWithRetryProps = Readonly<{
  msgKey: IntlKey;
  msg?: string | ReactNode;
  errorDetail?: string;
  errorDetailKey?: IntlKey;
  className?: string;
  severity?: AlertSeverity;
  e2e?: string;
  onRetry?: Nullable<() => void>;
}>;

export const ErrorWithRetry: FC<ErrorWithRetryProps> = ({
  msgKey,
  msg,
  errorDetail,
  errorDetailKey,
  e2e,
  onRetry,
  className,
  severity,
}) => {
  const { formatMessage } = useIntl();
  const formattedMsg = useMemo(
    () =>
      msg !== undefined
        ? msg
        : formatMessage({
            id: msgKey ?? 'discover.fetchData.error',
          }),
    [msg, msgKey, formatMessage],
  );
  let formattedDetail;
  if (errorDetail !== undefined) {
    formattedDetail = errorDetail;
  }
  if (errorDetailKey !== undefined) {
    formattedDetail = formatMessage({
      id: errorDetailKey,
    });
  }
  return (
    <div className="w-100">
      <LightAlert severity={severity ?? 'secondary'} e2e={e2e} className={className}>
        <span className="flex-grow-1">
          {formattedMsg}
          {formattedDetail !== undefined && <div className="font-italic fs-6">{formattedDetail}</div>}
        </span>

        {onRetry && (
          <button className={`btn btn-sm btn-outline-${severity ?? 'secondary'} float-end`} onClick={onRetry}>
            {formatMessage({
              id: 'retry',
              defaultMessage: 'retry',
            })}
          </button>
        )}
      </LightAlert>
    </div>
  );
};
